<template>
  <div v-if="value">
    <div class="modal-mask">
      <div class="modal modal-black modal-wrapper">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="modalTitle">{{ title }}</h4>
              <button data-dismiss="modal" aria-label="Close" @click="closeModal()" class="vs-dialog__close"><i class="vs-icon-close vs-icon-hover-x"></i></button>
            </div>
            <div class="modal-body" :style="scroll ? 'overflow: auto; max-height:75vh;' : ''">
              <slot name="body" data-testid="modal-body-slot"> </slot>
            </div>
            <div class="modal-footer d-flex justify-content-end mt-2">
              <button type="button" class="btn btn-secondary mr-1" id="closeButton" @click="closeModal()">Voltar</button>
              <button id="actionButton" :disabled='buttonDisabled' type="button" class="btn btn-primary" @click="confirmAction">
                {{ action }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationSuccess from '@/pages/Notifications/NotificationSuccess';
export default {
  name: 'modal',
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    action: {
      type: String,
    },
    value: {
      type: Boolean,
    },
    name: {
      type: String,
    },
    successMessage: {
      type: String,
    },
    message: {
      type: String,
    },
    error: {
      type: String,
    },
    scroll: {
      type: Boolean,
    },
    buttonDisabled:{
      type: Boolean,
    }
  },
  data() {
    return {
      deleteModal: true,
    };
  },

  methods: {
    closeModal: function () {
      this.$emit('closeModal');
    },
    confirmAction: function () {
      this.$emit('confirmAction');
    },
    notifySuccess() {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: 'Sucesso',
      });
    },
    notifyError(error) {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'danger',
        timeout: 3000,
        message: error,
      });
    },
    notifyVue() {
      let vm = this;
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: vm.successMessage,
      });
    },
  },
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.vs-dialog__close {
  color: #fff;
  position: absolute;
  top: -6px;
  right: -6px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #344675;
  border-radius: 12px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.3);
  transition: all 0.25s ease;
  z-index: 200;
  border: 0;
  cursor: pointer;
}
.vs-dialog__close:focus {
  outline: none;
}
.vs-dialog__close i {
  width: 34px;
  height: 34px;
  opacity: 0.7;
}
.vs-icon-close {
  width: 30px;
  height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.vs-dialog__close i:after,
.vs-dialog__close i:before {
  width: 26px;
}
.vs-icon-close:after,
.vs-icon-close:before {
  background: rgba(255, 255, 255, 1);
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.vs-dialog__close:hover {
  -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, var(--vs-shadow-opacity));
  -webkit-transform: translate(-2px, 2px);
  transform: translate(-2px, 2px);
}
.vs-dialog__close:hover i {
  opacity: 1;
}
</style>
